module.exports = __webpack_public_path__ + "img/hardware.8b506932.png";